<template>
  <div class="permissions-module">
    <el-tabs v-model="activeTab" @tab-change="handleTabChange">
      <el-tab-pane label="用户管理" name="users">
        <UserManagement ref="userMgmtRef" />
      </el-tab-pane>
      <el-tab-pane label="角色管理" name="roles">
        <RoleManagement ref="roleMgmtRef" />
      </el-tab-pane>
      <el-tab-pane label="权限管理" name="permissions">
        <PermissionManagement ref="permissionMgmtRef" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UserManagement from './UserManagement.vue'
import RoleManagement from './RoleManagement.vue'
import PermissionManagement from './PermissionManagement.vue'

const route = useRoute()
const router = useRouter()
const activeTab = ref(route.query.tab || 'users')

const userMgmtRef = ref(null)
const permissionMgmtRef = ref(null)

const roleMgmtRef = ref(null)

const handleTabChange = (tabName) => {
  router.replace({ query: { tab: tabName } })
  // 三个子页签组件同时挂载后不会重复执行 onMounted；切回时再拉数据，避免列表空白/新建角色选不到
  nextTick(() => {
    if (tabName === 'users') {
      userMgmtRef.value?.loadRoles?.()
    } else if (tabName === 'roles') {
      roleMgmtRef.value?.reload?.()
    } else if (tabName === 'permissions') {
      permissionMgmtRef.value?.refreshRoles?.()
    }
  })
}
</script>

<style scoped>
.permissions-module {
  padding: 0;
}

.coming-soon {
  padding: 60px 0;
}
</style>

